//authentication
export const LANDING = '/';
export const HOME = '/home';
export const INVOICE = '/invoice/:key';
export const PAYMENT_LINK = '/payment_link/:key';
export const UPDATE_RECURRING = '/recurring/:hash';
export const HOSTED = '/hosted';
